(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jack-lessing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scope = document.querySelectorAll('.jl-section');
    if (!scope.length) return;

    // Reveal on scroll
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      scope.forEach(function (root) {
        root.querySelectorAll('.reveal').forEach(function (el) {
          io.observe(el);
        });
      });
    } else {
      scope.forEach(function (root) {
        root.querySelectorAll('.reveal').forEach(function (el) {
          el.classList.add('in');
        });
      });
    }

    // FAQ accordion
    scope.forEach(function (root) {
      root.querySelectorAll('[data-faq]').forEach(function (item) {
        item.addEventListener('click', function () {
          var wasOpen = item.classList.contains('open');
          root.querySelectorAll('[data-faq]').forEach(function (i) {
            i.classList.remove('open');
            var t = i.querySelector('.faq-toggle');
            if (t) t.textContent = '+';
          });
          if (!wasOpen) {
            item.classList.add('open');
            var t = item.querySelector('.faq-toggle');
            if (t) t.textContent = '−';
          }
        });
      });
    });

    // Hero video play/pause toggle
    // scope.forEach(function (root) {
    //   var videoHero = root.querySelector('[data-hero-card-video-jl]');
    //   var btn = root.querySelector('[data-hero-card-playbtn-jl]');
    //   if (!videoHero || !btn) return;

    //   function setState(isPlaying) {
    //     btn.classList.toggle('is-playing', isPlaying);
    //     btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    //     btn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    //   }

    //   btn.addEventListener('click', function () {
    //     if (videoHero.paused || videoHero.ended) {
    //       var p = video.play();
    //       if (p && typeof p.catch === 'function') {
    //         p.catch(function () {
    //           setState(false);
    //         });
    //       }
    //     } else {
    //       videoHero.pause();
    //     }
    //   });

    //   // Listen on the video itself — state stays accurate no matter what triggers play/pause
    //   videoHero.addEventListener('play', function () {
    //     setState(true);
    //   });
    //   videoHero.addEventListener('pause', function () {
    //     setState(false);
    //   });
    //   videoHero.addEventListener('ended', function () {
    //     setState(false);
    //   });

    //   // Initial sync — covers both autoplay success and autoplay-blocked
    //   setState(!videoHero.paused && !videoHero.ended);
    // });

    // ── Hero video — play / pause toggle ───────────────────────────────────────
    scope.forEach(function (root) {
      var videoHero = root.querySelector('[data-hero-card-video-jl]');
      var btn = root.querySelector('[data-hero-card-playbtn-jl]');
      if (!videoHero || !btn) return;

      function setState(isPlaying) {
        btn.classList.toggle('is-playing', isPlaying);
        btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        btn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      }

      btn.addEventListener('click', function () {
        console.log('clicked', videoHero);
        if (videoHero.paused || videoHero.ended) {
          var p = videoHero.play();
          if (p && typeof p.catch === 'function')
            p.catch(function () {
              setState(false);
            });
        } else {
          videoHero.pause();
        }
      });

      videoHero.addEventListener('play', function () {
        setState(true);
      });
      videoHero.addEventListener('pause', function () {
        setState(false);
      });
      videoHero.addEventListener('ended', function () {
        setState(false);
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        videoHero.removeAttribute('autoplay');
        videoHero.pause();
        setState(false);
      } else {
        setState(!videoHero.paused && !videoHero.ended);
      }
    });

    scope.forEach(function (root) {
      var grid = root.querySelector('[data-video-grid-jl]');
      if (!grid) return;

      var mode = grid.getAttribute('data-playback') || 'hover';
      var cards = grid.querySelectorAll('[data-video-card-jl]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      cards.forEach(function (card) {
        var video = card.querySelector('[data-video-card-video-jl]');
        var toggle = card.querySelector('[data-video-card-toggle-jl]');
        if (!video) return;

        function setState(playing) {
          card.classList.toggle('is-playing', playing);
          if (toggle) toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
        }

        function safePlay() {
          var p = video.play();
          if (p && typeof p.catch === 'function')
            p.catch(function () {
              setState(false);
            });
        }

        video.addEventListener('play', function () {
          setState(true);
        });
        video.addEventListener('pause', function () {
          setState(false);
        });
        video.addEventListener('ended', function () {
          setState(false);
        });

        if (toggle) {
          toggle.addEventListener('click', function () {
            if (video.paused || video.ended) safePlay();
            else video.pause();
          });
        }

        if (mode === 'hover' && !reducedMotion) {
          card.addEventListener('mouseenter', safePlay);
          card.addEventListener('mouseleave', function () {
            video.pause();
            video.currentTime = 0;
          });
        }

        if (mode === 'autoplay' && reducedMotion) {
          video.removeAttribute('autoplay');
          video.pause();
        }

        setState(!video.paused && !video.ended);
      });

      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              var v = e.target;
              if (!e.isIntersecting && !v.paused) {
                v.pause();
              } else if (e.isIntersecting && mode === 'autoplay' && !reducedMotion && v.paused) {
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              }
            });
          },
          { threshold: 0.25 }
        );

        cards.forEach(function (card) {
          var v = card.querySelector('[data-video-card-video-jl]');
          if (v) vio.observe(v);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
